<template>
  <v-container
    class="asc-query-builder-function-grid-container pa-4"
    :style="{ width: `${gridWidth}px` }"
  >
    <v-row class="function-grid-operator mb-1">
      <v-col>
        <asc-tooltip
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :tooltip-length="100"
          :left="true"
        >
          <asc-accent-button
            v-for="(button, index) in expressionOptions"
            :key="index"
            :button-text="button.text"
            :value="button"
            :on-click="handleGridFunctionClick"
            :outline="true"
            :secondary="true"
            :icon-only="button.icon ? button.icon : true"
            :icon="button.icon ? button.icon : true ? button.text : ''"
            :class="`order-${button.order}`"
            :custom-class="getButtonClass(button)"
            :disabled="isDataBricksRunning ? true : false"
          />
        </asc-tooltip>
      </v-col>
    </v-row>
    <v-row
      v-if="advancedFunctionList.length || disabledFunctionOption"
      no-gutters
      class="selectorRow mb-2 ml-2 advFunctions"
    >
      <v-col :cols="getSelectorRowSelectorCols">
        <asc-tooltip
          left
          :tooltip="
            advancedFunctionTooltip
              ? advancedFunctionTooltip
              : isDataBricksRunning
              ? tooltipMsg
              : ''
          "
          :tooltip-length="advancedFunctionTooltip ? 0 : 100"
        >
          <asc-autocomplete-selector
            v-model="advancedFunctionItem"
            label="Adv. Functions"
            no-array
            placeholder="Select Function"
            :disabled="
              disabledFunctionOption ? true : isDataBricksRunning ? true : false
            "
            :items="advancedFunctionList"
          />
        </asc-tooltip>
      </v-col>
      <v-col :cols="getSelectorRowButtonCols" class="d-flex justify-end pt-1">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-accent-button
            button-text="Apply"
            :disabled="
              disabledFunctionOption ||
              advancedFunctionItem === null ||
              isDataBricksRunning
            "
            :outline="true"
            :secondary="true"
            :large="true"
            :on-click="handleApplySelectedAdvFunction"
          />
        </asc-tooltip>
      </v-col>
    </v-row>
    <v-row
      v-if="isAdvancedDplf"
      no-gutters
      class="selectorRow mb-2 mt-2 ml-2 messageCode"
    >
      <v-col
        :cols="getSelectorRowSelectorCols"
        class="function-grid-message-code"
      >
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-autocomplete-selector
            v-model="messageCodeItem"
            no-array
            label="Fault Code"
            placeholder="Select Message Code"
            :items="messageCodes"
            :disabled="isDataBricksRunning"
          />
        </asc-tooltip>
      </v-col>
      <v-col :cols="getSelectorRowButtonCols" class="d-flex justify-end pt-1">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-accent-button
            button-text="Apply"
            :outline="true"
            :secondary="true"
            :large="true"
            :on-click="handleApplySelectedMessageCode"
            :disabled="isDataBricksRunning"
          />
        </asc-tooltip>
      </v-col>
    </v-row>
    <v-row v-else no-gutters class="selectorRow mb-2 mt-2 ml-2 parameter">
      <v-col :cols="getSelectorRowSelectorCols" class="function-grid-parameter">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-autocomplete-selector
            v-model="parameterItem"
            no-array
            label="Parameter"
            placeholder="Select Parameter"
            detail-row-prop="value"
            class="asc-selector--detailRow"
            :items="parameterList"
            :item-height="44"
            :disabled="isDataBricksRunning"
          />
        </asc-tooltip>
      </v-col>
      <v-col :cols="getSelectorRowButtonCols" class="d-flex justify-end pt-1">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-accent-button
            button-text="Apply"
            :disabled="parameterItem === null || isDataBricksRunning"
            :outline="true"
            :secondary="true"
            :large="true"
            :on-click="handleApplySelectedParameter"
          />
        </asc-tooltip>
      </v-col>
    </v-row>
    <v-row
      v-if="(isAdvancedFullFlight || isAdvancedDplf) && flightPhaseList.length"
      no-gutters
      class="selectorRow mb-2 mt-2 ml-2 flightPhase"
    >
      <v-col :cols="getSelectorRowSelectorCols">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-autocomplete-selector
            v-model="flightPhaseItem"
            no-array
            label="Flight Phase"
            placeholder="Select Flight Phase"
            :sort-items="false"
            :items="flightPhaseList"
            :disabled="isDataBricksRunning"
          />
        </asc-tooltip>
      </v-col>
      <v-col :cols="getSelectorRowButtonCols" class="d-flex justify-end pt-1">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <asc-accent-button
            button-text="Apply"
            :disabled="flightPhaseItem === null || isDataBricksRunning"
            :outline="true"
            :secondary="true"
            :large="true"
            :on-click="handleApplySelectedFlightPhase"
          />
        </asc-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  components: {
    AscAccentButton,
    AscAutocompleteSelector,
    AscTooltip,
  },

  props: {
    tooltipMsg: {
      type: String,
      default: '',
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    gridWidth: {
      type: Number,
      default: 400,
    },
    configurationOption: {
      type: String,
      default: '',
    },
    isAdvancedFullFlight: {
      type: Boolean,
      default: false,
    },
    isAdvancedDplf: {
      type: Boolean,
      default: false,
    },
    expressionOptions: {
      type: Array,
      default: () => [],
    },
    messageCodes: {
      type: Array,
      default: () => [],
    },
    parameterList: {
      type: Array,
      default: () => [],
    },
    flightPhaseList: {
      type: Array,
      default: () => [],
    },
    advancedFunctionList: {
      type: Array,
      default: () => [],
    },
  },

  data: function () {
    return {
      parameterItem: null,
      messageCodeItem: null,
      flightPhaseItem: null,
      advancedFunctionItem: null,
      isStorybook: false,
    }
  },

  computed: {
    disabledFunctionOption() {
      if (
        this.isAdvancedDplf ||
        this.isAdvancedFullFlight ||
        this.configurationOption === 'aggregateDays' ||
        this.configurationOption === 'aggregateReports'
      ) {
        return false
      }

      return true
    },

    advancedFunctionTooltip() {
      if (this.disabledFunctionOption) {
        return 'Only available when aggregation is configured.'
      } else {
        return ''
      }
    },

    getSelectorRowSelectorCols() {
      return this.gridWidth >= 400 ? 9 : 8
    },

    getSelectorRowButtonCols() {
      return this.gridWidth >= 400 ? 3 : 4
    },
  },

  methods: {
    handleGridFunctionClick(e, value) {
      this.$emit('input', e, value)
    },

    getButtonClass(button) {
      const btnClass = []
      if (button.icon === false) btnClass.push('hasLabel')
      if (button.color) btnClass.push(`color-${button.color}`)
      return btnClass.join(' ')
    },

    handleApplySelectedParameter() {
      const selectedParameter = this.parameterList.filter(
        item => item.value === this.parameterItem,
      )

      if (selectedParameter && selectedParameter.length === 1) {
        this.$emit('input', '', selectedParameter[0])
      }
    },

    handleApplySelectedMessageCode() {
      const selectedMessageCode = this.messageCodes.filter(
        item => item.value === this.messageCodeItem,
      )
      if (selectedMessageCode && selectedMessageCode.length === 1) {
        this.$emit('input', '', selectedMessageCode[0])
      }
    },

    handleApplySelectedAdvFunction() {
      const selectedAdvancedFunction = this.advancedFunctionList.filter(
        item => item.value === this.advancedFunctionItem,
      )
      if (selectedAdvancedFunction && selectedAdvancedFunction.length === 1) {
        this.$emit('input', '', selectedAdvancedFunction[0])
      }
    },

    handleApplySelectedFlightPhase() {
      const selectedflightPhase = this.flightPhaseList.filter(
        item => item.value === this.flightPhaseItem,
      )
      if (selectedflightPhase && selectedflightPhase.length === 1) {
        this.$emit('input', '', selectedflightPhase[0])
      }
    },
  },
}
</script>

<style lang="scss">
.asc-query-builder-function-grid-container {
  display: flex;
  flex-direction: column;
  background-color: $gray-100;

  .asc-accent-button {
    float: left;
    margin: 5px !important;
  }

  .function-grid-operator {
    .hasLabel {
      width: 82px;
    }

    .v-btn {
      &.color-success {
        color: $semantic-success !important;
      }

      &.color-purple {
        color: rgb(185, 0, 252) !important;
      }

      &.color-blue {
        color: blue !important;
      }

      &.color-magenta {
        color: magenta !important;
      }

      &.color-accent {
        color: $accent-600 !important;
      }

      &.color-caution {
        color: $caution-base !important;
      }

      &.color-yellow {
        color: rgb(208, 159, 14) !important;
      }

      &.color-red {
        color: red !important;
      }

      &__content {
        color: inherit;

        .v-icon {
          font-family: inherit;
          font-size: 0.9rem !important;
        }
      }
    }
  }

  .asc-autocomplete-selector--hasDetails {
    .asc-selector--list-item {
      height: 100%;

      &-label--container {
        display: flex;
        flex-direction: column;
      }

      &-label-subtitle {
        color: $semantic-warning;
        font-size: 0.8rem;
      }
    }
  }
}
</style>
